module.exports = __webpack_public_path__ + "img/communication_path.19066145.png";